import _ from 'lodash';
import {apiFetch } from '../utility';

const apiBase = 'vendorBill';
const VENDOR_BILL_RESULT = 'accounting/vendorBill/SEARCH/';
const VENDOR_BILL_STATUS_CHANGE = 'accounting/vendorBill/CHANGE';

const initialState = {
	byStationId : {},
	byStatus : {},
};

export default (state = initialState, action) => {

	if (action.type === VENDOR_BILL_RESULT) {
		if (action.status) {
			return {
				...state,
				byStatus: {
					...state.byStatus,
					[action.status]: _.map(action.vendorBills, 'vendorBillId'),
				}
			};
		} else {
			return state;
		}
	} else if (action.type === VENDOR_BILL_STATUS_CHANGE) {
		const {status, vendorBillId} = action.vendorBill;

		const pendingIds = _.get(state, ['byStatus', 'pending']);
		const completedIds  = _.get(state, ['byStatus', 'completed']);
		if (!pendingIds || !completedIds) {
			return state;
		}

		//- New pending vendorBill means it is not done yet
		if (status === 'pending') {
			const newPendingIds = _.uniq(pendingIds.concat([vendorBillId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
				}
			};
		}

		if (status === 'completed' || status === 'invalid') {
			const newCompletedIds = _.uniq(completedIds.concat([vendorBillId]));
			const newPendingIds = _.filter(pendingIds, id => {
				return id !== vendorBillId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					completed: newCompletedIds,
				}
			};
		}
	} else {
		return state;
	}
};

export const search = (p) => {
	const {
		status,
		stationId,
		afterDate,
		callback = _.noop,
	} = p;

	return dispatch => {
		const params = {
			status,
			afterDate,
			stationId
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }

				const vendorBills = _.get(r, ['collections', 'vendorBillCollection']);
				dispatch({
					type: VENDOR_BILL_RESULT,
					status,
					stationId,
					vendorBills,
				});
				callback();
			}
		});
	};
};


export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'vendorBillIds',
			params,
			dispatch,
			//successMessage : `The ${word} was created successfully.
			//	Click continue to return to the ${word} page.`,
			//onSuccessRedirectTo : `/accounting/${plural}`,
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};
export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getDetails = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getDetails`,
			params,
			dispatch,
			callback,
		});
	};
};

export const exportToQuickbooks = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.export`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const vendorBill = _.get(r, ['collections', 'vendorBillCollection', 0]);
				dispatch({
					type: VENDOR_BILL_STATUS_CHANGE,
					vendorBill,
				});
				callback();
			}
		});
	};
};

export const invalidate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const vendorBill = _.get(r, ['collections', 'vendorBillCollection', 0]);
				dispatch({
					type: VENDOR_BILL_STATUS_CHANGE,
					vendorBill,
				});
				callback();
			}
		});
	};
};
